<template>
    <div class="note note-element"
         :style="data.styleNote"
         :class="data.classNote"
         @mousedown="onMouseDown"
         @touchstart="onMouseDown"
         ref="refNote"
    >
        <div v-show="data.isMaximized">
            <div class="note-header note-element">
                <a class="btn-del hover-effect"
                   href="#"
                >
                     <img class="no-pointer" src="~/images/btn_del_note.svg">
                </a>
                <div class="title-container no-select note-element">
                    <input type="text"
                           class="note-element"
                           :placeholder="i18n.t('label_enter_note_name')"
                           :class="data.classInputTitle"
                           @mousedown="noteFieldOnMouseDown"
                           @touchstart="noteFieldOnMouseDown"
                           @focus="setActiveNote(props.meta.id, props.pagenum)"
                           @keyup="updateNote"
                           @focusout="onFocusOut"
                           v-model="data.title"
                    >
                </div>
                <a class="btn-minimize hover-effect note-element"
                   href="#"
                >
                    <img class="no-pointer" src="~/images/btn_min_bookmark.svg">
                </a>
            </div>
            <textarea class="note-content note-element"
                      @mousedown="noteFieldOnMouseDown"
                      @touchstart="noteFieldOnMouseDown"
                      @keyup="updateNote"
                      @focus="setActiveNote(props.meta.id, props.pagenum)"
                      @focusout="onFocusOut"
                      v-model="data.content">

            </textarea>
        <!-- the drag-mask layer is to avoid the button from being interacted when the note is being dragged-->
        </div>
        <!--<div class="drag-mask"
             v-show="data.isDragging && data.isMaximized"
        >
        </div>-->
    </div>
</template>

<script>

    import {ref, reactive, onMounted, onUpdated, watchEffect, computed, watch, nextTick, inject}  from "vue"
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {usePaging} from "@/modules/reader/book/paging";
    import {useTool} from "@/modules/reader/tools/tools";
    import config from "@/config/config.json";
    import cssvar from '@/scss/_variables.scss';
    import {toolState} from "../../../../modules/reader/tools/tools";
    import {isTouchDevice, deviceType} from "@/modules/utils/deviceUtils";

    const noteHeight = parseInt(cssvar.noteHeight);
    const noteWidth =  parseInt(cssvar.noteWidth);
    const headerHeight = parseInt(cssvar.headerHeight);
    const noteMinSize = parseInt(cssvar.noteMinSize);

    export default {
        components: {

        },
        props: {
            pagenum:Number,
            meta:Object,
            index:Number,
            side:String,
            disabled:false
        },
        setup(props, context) {

            let scrollOffsetLeft; //set the body scroll left offset value to position the note correctly on tablet
            let scrollOffsetTop;
            const i18n = inject('i18n')
            const {pageResizeState}= usePageResize();
            const {pageState} = usePaging();
            const {toolState, TOOL_NOTE, deleteNote, setActiveNote, clearActiveNote, updateNoteMaximizedState} = useTool();
            const refNote = ref(null);
            let noteContainerRect = {
                x:0,
                y:0
            }

            const data = reactive({
                isMaximized:props.meta.isMaximized,
                isPosUpdated:false,  //tell whether the note coordinates have been updated, if not, use props pos, otherwise, use the new position after dragging
                noteContainerWidth:computed(()=>{
                    return Math.round(pageResizeState.imgToBrowserScale * pageResizeState.baseWidth * data.zoomLevel);
                }),
                noteContainerHeight:computed(()=>{
                    return Math.round(pageResizeState.imgToBrowserScale * pageResizeState.baseHeight * data.zoomLevel);
                }),
                isBothLeftRightMarginNotEnough:false, //when note is minimized, this is true if both left and right margins are not enough to fit the note
                styleNote: computed(()=>{
                    return {
                        transform: `scale3d(${1 / data.zoomLevel}, ${1 / data.zoomLevel}, 1)`,
                        transformOrigin: "left top",
                        //left: data.isPosUpdated ? `${toolState.noteList[props.pagenum][props.index].x *  pageResizeState.currentInitialRatio}px` : `${props.meta.x *  pageResizeState.currentInitialRatio}px`,
                        //top: data.isPosUpdated ? `${toolState.noteList[props.pagenum][props.index].y *  pageResizeState.currentInitialRatio}px` : `${props.meta.y * pageResizeState.currentInitialRatio}px`,
                        left: data.isPosUpdated ? `${toolState.noteList[props.pagenum][props.index].x *  pageResizeState.imgToBrowserScale}px` : `${props.meta.x *  pageResizeState.imgToBrowserScale}px`,
                        top: data.isPosUpdated ? `${toolState.noteList[props.pagenum][props.index].y *  pageResizeState.imgToBrowserScale}px` : `${props.meta.y * pageResizeState.imgToBrowserScale}px`,
                        //left: data.isPosUpdated ? `${toolState.noteList[props.pagenum][props.index].x}px` : `${props.meta.x}px`,
                        //top: data.isPosUpdated ? `${toolState.noteList[props.pagenum][props.index].y}px` : `${props.meta.y}px`,
                        zIndex: getZIndex(),
                    }
                }),
                classNote: computed(()=>{
                    return {
                        "no-border": !data.isMaximized,
                        "minimized": !data.isMaximized,
                        "disabled": props.disabled,
                    }
                }),
                /**
                 * Title input will have to be enlarged, otherwise, the text couldn't show on iPad when page is zoomed in
                 */
                classInputTitle: computed(()=>{
                    return {
                        "is-touch": isTouchDevice()
                    }
                }),
                minimizedPos:{
                    x:props.meta.minPosX,
                    y:props.meta.minPosY
                },
                offsetX:0, //store the difference between the mouse x coordinate and the note left coordinate, so that the note will not move when mousemove starts
                offsetY:0,  //store the difference between the mouse y coordinate and the note top coordinate, so that the note will not move when mousemove starts
                isDragging:false,
                isTopOutOfBound:false,
                isLeftOutOfBound:false,
                isBottomOutOfBound:false,
                isRightOutOfBound:false,
                mouseDownPos:{}, //store mouse x,y pos on mouse down, used to detect if note is dragged. If not dragged, maximize the note if it's minimized
                mouseUpPos:{}, //store mouse x,y pos on mouse up, used to detect if note is dragged. If not dragged, maximize the note if it's minimized
                noteWidth:noteWidth, //set as data property so that it can be accessed in watchEffect
                noteHeight:noteHeight,
                noteMinSize:noteMinSize, //set as data property so that it can be accessed in watchEffect
                //TODO: move to helper method, don't repeat yourself
                zoomLevel: computed(()=>{
                    if (pageState.isRightPageAvailable) {
                        if (props.side === "left") {
                            return pageResizeState.zoomLevelLeft;
                        } else if (props.side === "right") {
                            return pageResizeState.zoomLevelRight;
                        }
                    } else {
                        return pageResizeState.zoomLevel;
                    }
                }),
                title: props.meta.title,
                content: props.meta.content,
                refNote:null,
            })


            const minimizeNote = ()=> {
                data.isMaximized = false;

                if (data.minimizedPos.x !== undefined && data.minimizedPos.y !== undefined ) {
                    updatePosX(data.minimizedPos.x)
                    updatePosY(data.minimizedPos.y)
                }

                updateNoteMaximizedState(props.pagenum, props.index, false);
            }

            /**
             * Avoid input and textarea text selection conflict with mousemove event.
             */
            const noteFieldOnMouseDown = (e)=>{
                e.stopPropagation();
                return;
            }

            const onMouseDown = (e)=>{

                //call preventDefault to prevent the default click behavior if the target element is <a> tag (which is either of the buttons of deleting or minimizing  note).
                //Otherwise, when mouse down event is listened by the <a> tag, mousemove handler won't be listened!

                e.preventDefault();
                let x,y;
                toolState.isUsing = true;

                //TODO: move to helper method, don't repeat yourself
                data.mouseDownPos = {
                    //x: (isTouchDevice()) ? e.changedTouches[0].pageX : e.clientX,
                    //y: (isTouchDevice()) ? e.changedTouches[0].pageY : e.clientY,
                    x: (isTouchDevice() && e.changedTouches && e.changedTouches.length) ? e.changedTouches[0].pageX : e.clientX,
                    y: (isTouchDevice() && e.changedTouches && e.changedTouches.length) ? e.changedTouches[0].pageY : e.clientY
                }

                data.mouseDownPos.x = Math.round(data.mouseDownPos.x * 100) / 100;
                data.mouseDownPos.y = Math.round(data.mouseDownPos.y * 100) / 100;

                //get the bounding rect of the note parent, i.e. the note container
                let bounds = refNote.value.parentElement.getBoundingClientRect();
                noteContainerRect.left = bounds.left;
                noteContainerRect.top = bounds.top;
                scrollOffsetLeft =  data.isMaximized ? 0 : noteContainerRect.left + document.body.scrollLeft;  //need consider body scrollLeft for tablet
                scrollOffsetTop =  data.isMaximized ? 0 : noteContainerRect.top + document.body.scrollTop - headerHeight;  //need consider body scrollTop offset for tablet

                if (isTouchDevice() && e.changedTouches && e.changedTouches.length) {
                    x = (data.mouseDownPos.x - scrollOffsetLeft) / data.zoomLevel / pageResizeState.imgToBrowserScale
                    y = (data.mouseDownPos.y - scrollOffsetTop) / data.zoomLevel / pageResizeState.imgToBrowserScale
                } else {
                    if (deviceType() === 'desktop' || noteContainerRect.left >= 0 && noteContainerRect.top >= 0) {
                        x = (data.mouseDownPos.x - noteContainerRect.left) / data.zoomLevel / pageResizeState.imgToBrowserScale
                        y = (data.mouseDownPos.y - noteContainerRect.top) / data.zoomLevel / pageResizeState.imgToBrowserScale
                    } else {
                        x = data.mouseDownPos.x / data.zoomLevel / pageResizeState.imgToBrowserScale;
                        y = data.mouseDownPos.y / data.zoomLevel / pageResizeState.imgToBrowserScale;
                    }
                }

                //if it's the first time the note is dragged, use the initial coordinate to get the offset, otherwise, use the current note position.
                if (!data.isPosUpdated) {
                    data.offsetX = x  - props.meta.x
                    data.offsetY = y - props.meta.y
                } else {
                    data.offsetX = x - toolState.noteList[props.pagenum][props.index].x
                    data.offsetY = y - toolState.noteList[props.pagenum][props.index].y
                }

                data.offsetX = Math.round( data.offsetX * 100) / 100;
                data.offsetY = Math.round( data.offsetY * 100) / 100;

                setActiveNote(props.meta.id, props.pagenum);

                //TODO: test adding mouseout so that the note won't sitck to the mouse if page is scrollable and note is dragged out...
                document.addEventListener("mousemove", onMouseMove);
                document.addEventListener("touchmove", onMouseMove);
                document.addEventListener("mouseup", onMouseUp);
                document.addEventListener("touchend", onMouseUp);
            }


            const onMouseMove = (e)=> {

                e.preventDefault();

                let x,y;
                data.isPosUpdated = true;
                data.isDragging = true;
                data.isTopOutOfBound = false;
                data.isLeftOutOfBound = false;
                data.isBottomOutOfBound = false;
                data.isRightOutOfBound = false;

                //TODO: move to helper method, don't repeat yourself
                if (!(isTouchDevice() && e.changedTouches && e.changedTouches.length)) {
                    x = e.clientX - noteContainerRect.left
                    y = e.clientY - noteContainerRect.top
                } else {
                    x = e.changedTouches[0].pageX  - (scrollOffsetLeft >=0 ? scrollOffsetLeft : 0);
                    y = e.changedTouches[0].pageY  - (scrollOffsetTop >=0 ? scrollOffsetTop : 0)
                }

                let noteWidth = data.isMaximized ? data.noteWidth : data.noteMinSize;
                let noteHeight = data.isMaximized ? data.noteHeight : data.noteMinSize;

                //left out of boundary
                if (!data.isMaximized && (isTouchDevice() && e.changedTouches && e.changedTouches.length)) {
                    if (x < 0) {
                        data.isLeftOutOfBound = true;
                    }
                } else {
                    if (x - data.offsetX * data.zoomLevel * pageResizeState.imgToBrowserScale < 0) {
                        data.isLeftOutOfBound = true;
                    }
                }

                //top out of boundary
                if (y - data.offsetY * data.zoomLevel * pageResizeState.imgToBrowserScale < 0) {
                    data.isTopOutOfBound = true;
                }

                //bottom out of boundary
                if (y - data.offsetY * data.zoomLevel * pageResizeState.imgToBrowserScale > data.noteContainerHeight - noteHeight ) {
                    data.isBottomOutOfBound = true;
                }

                //right out of boundary
                if (!data.isMaximized && (isTouchDevice() && e.changedTouches && e.changedTouches.length)) {
                     if (x >  data.noteContainerWidth - noteWidth) {
                         data.isRightOutOfBound = true;
                     }
                } else {
                    if (x - data.offsetX * data.zoomLevel * pageResizeState.imgToBrowserScale > data.noteContainerWidth - noteWidth) {
                        data.isRightOutOfBound = true;
                    }
                }

                constraintPos();

               if (!data.isTopOutOfBound && !data.isBottomOutOfBound) {
                    updatePosY(y / pageResizeState.imgToBrowserScale / data.zoomLevel - data.offsetY);
                }

                if (!data.isLeftOutOfBound && !data.isRightOutOfBound) {
                    updatePosX(x / pageResizeState.imgToBrowserScale / data.zoomLevel - data.offsetX);
                }
            }

            const onMouseUp = (e)=>{

                e.preventDefault();

                console.log("on mouse up!")
                data.mouseUpPos = {
                    x: (isTouchDevice() && e.changedTouches && e.changedTouches.length) ? e.changedTouches[0].pageX : e.clientX,
                    y: (isTouchDevice() && e.changedTouches && e.changedTouches.length) ? e.changedTouches[0].pageY : e.clientY,
                }

                data.mouseUpPos.x = Math.round(data.mouseUpPos.x * 100) / 100;
                data.mouseUpPos.y = Math.round(data.mouseUpPos.y * 100) / 100;

                let touchStartEndDeltaX = Math.abs(data.mouseDownPos.x - data.mouseUpPos.x);
                let touchStartEndDeltaY = Math.abs(data.mouseDownPos.y - data.mouseUpPos.y);
                //let tolerance = isTouchDevice() ? config.reader.tool.note.touchStartEndDeltaTolerance : 0;

                checkNoteLeftRightSpace();

                //check if dragging has occurred, if not,mouse down and mouse up position should have no difference ( may not be accurate on android, so check data.isDragging  also)
                //if ((touchStartEndDeltaX <= tolerance && touchStartEndDeltaY <= tolerance) || !data.isDragging) {
                if ((touchStartEndDeltaX <= 0 && touchStartEndDeltaY <= 0) || !data.isDragging) {
                    if (!data.isMaximized) {

                       //Note, check the bound data again, otherwise, the top data might be wrong on tablet...
                       let bounds = refNote.value.parentElement.getBoundingClientRect();

                       //data.minimizedPos.x =  toolState.noteList[props.pagenum][props.index].x;
                       //data.minimizedPos.y =  toolState.noteList[props.pagenum][props.index].y;

                       //if both left and right half of the page can fit note
                       if (!data.isBothLeftRightMarginNotEnough) {

                           //check if note will be cut by boundary after maximized, if yes, move it within the note container

                           if (bounds.height - toolState.noteList[props.pagenum][props.index].y * pageResizeState.imgToBrowserScale *  data.zoomLevel < noteHeight) {
                                updatePosY(toolState.noteList[props.pagenum][props.index].y - (data.noteHeight - data.noteMinSize) / data.zoomLevel);
                            }
                            if (bounds.width - toolState.noteList[props.pagenum][props.index].x * pageResizeState.imgToBrowserScale  * data.zoomLevel < noteWidth) {
                                updatePosX(toolState.noteList[props.pagenum][props.index].x - (data.noteWidth - data.noteMinSize) / data.zoomLevel)
                            }

                        //otherwise, the note container is small, we'll have to adjust the position. No need to consider data.zoomlevel since it only happens when zoom level = 1
                        } else {

                          // console.log("@mousup " + bounds.width + " ; " + " ; " + " ; " + toolState.noteList[props.pagenum][props.index].x +  " ; " + noteWidth)
                           if (bounds.width - toolState.noteList[props.pagenum][props.index].x * pageResizeState.imgToBrowserScale  < noteWidth) {
                               if ( toolState.noteList[props.pagenum][props.index].x < noteWidth) {
                                   updatePosX(0)
                               } else {
                                   //updatePosX( toolState.noteList[props.pagenum][props.index].x - (data.noteWidth - data.noteMinSize));
                                   updatePosX( (bounds.width - noteWidth) / pageResizeState.imgToBrowserScale);
                               }
                           }

                           if (bounds.height - toolState.noteList[props.pagenum][props.index].y * pageResizeState.imgToBrowserScale < noteHeight) {

                               if ( toolState.noteList[props.pagenum][props.index].y < noteHeight) {
                                   updatePosY(0)
                               } else {
                                   updatePosY( (bounds.height - noteHeight) / pageResizeState.imgToBrowserScale);
                               }
                           }

                       }

                        updateNoteMaximizedState(props.pagenum, props.index, true);
                        data.isMaximized = true;

                    }  else {

                        if (e.target.className) {
                            //if the click target is the minimize button, then minimize the note
                            if (e.target.className.indexOf("btn-minimize") >= 0) {
                                minimizeNote();
                                //if the click target is the delete button, then delete the note
                            } else if (e.target.className.indexOf("btn-del") >= 0) {
                                deleteNote(props.pagenum, props.meta.id)
                            }
                        }
                    }
                } else {
                    data.minimizedPos.x = toolState.noteList[props.pagenum][props.index].x;
                    data.minimizedPos.y = toolState.noteList[props.pagenum][props.index].y;
                }

                document.removeEventListener("mousemove", onMouseMove);
                document.removeEventListener("touchmove", onMouseMove);
                document.removeEventListener("mouseup", onMouseUp);
                document.removeEventListener("touchend", onMouseUp);
                clearActiveNote();
                updateNote();
                data.isDragging = false;
                toolState.isUsing = false;

            }

            const getZIndex = ()=>{

                for (let [index,item] of toolState.noteOrdering[props.pagenum].entries()) {
                    if (item === props.meta.id) {
                        return index;
                    }
                }
            }

            const updatePosX = (x) =>{
                toolState.noteList[props.pagenum][props.index].x = Math.round(x * 100) / 100;
            }

            const updatePosY= (y) =>{
                toolState.noteList[props.pagenum][props.index].y = Math.round(y * 100) / 100;
            }

            /**
             * Force the note to position within the note container if it's about to move out of boundary
             */
            const constraintPos = ()=>{

                let noteWidth = data.isMaximized ? data.noteWidth : data.noteMinSize;
                let noteHeight = data.isMaximized ? data.noteHeight : data.noteMinSize;

                if (data.isRightOutOfBound) {
                    let x = Math.floor((data.noteContainerWidth  - noteWidth) / data.zoomLevel /pageResizeState.imgToBrowserScale);
                    data.minimizedPos.x = x;
                    updatePosX(x);
                }

                if (data.isTopOutOfBound) {
                    updatePosY(0);
                }

                if (data.isLeftOutOfBound) {
                    updatePosX(0);
                }

                if (data.isBottomOutOfBound) {
                    let y = Math.floor(( data.noteContainerHeight - noteHeight) / data.zoomLevel / pageResizeState.imgToBrowserScale);
                    data.minimizedPos.y  = y;
                    updatePosY(y);
                }

            }

            const rePositionOnBoundaryReached = ()=>{

                console.log("rePositionOnBoundaryReached " + props.pagenum);

                //note we don't change minimizedPos pos if it's maximized, since the note may be newly added and the min pos is close to boundary;
                //We expect the min pos is restored to where it's clicked, when later if it's minimized
                if (data.isMaximized) {

                    console.log("rePositionOnBoundaryReached maximzed : " + toolState.noteList[props.pagenum][props.index].y + " ; " +  data.minimizedPos.y + " ; "  + pageResizeState.imgToBrowserScale + " ; " + data.zoomLevel + " ; " + data.noteContainerWidth + " ; " + data.noteContainerHeight)

                    if (Math.ceil(data.minimizedPos.x * pageResizeState.imgToBrowserScale * data.zoomLevel + noteWidth ) >= data.noteContainerWidth) {
                        //data.isPosUpdated = true;
                        if ( data.zoomLevel > 1) {
                            updatePosX(Math.floor(data.noteContainerWidth / data.zoomLevel / pageResizeState.imgToBrowserScale - noteWidth / data.zoomLevel /pageResizeState.imgToBrowserScale));
                        } else {
                            updatePosX( Math.floor(data.noteContainerWidth / pageResizeState.imgToBrowserScale - noteWidth  / pageResizeState.imgToBrowserScale));
                        }
                    }

                    if (Math.ceil(data.minimizedPos.y * pageResizeState.imgToBrowserScale * data.zoomLevel + noteHeight  ) >= data.noteContainerHeight) {
                        //data.isPosUpdated = true;
                        if ( data.zoomLevel > 1){
                            updatePosY(Math.floor(data.noteContainerHeight / data.zoomLevel / pageResizeState.imgToBrowserScale - noteHeight / data.zoomLevel /pageResizeState.imgToBrowserScale));
                        } else {
                            updatePosY(Math.floor(data.noteContainerHeight  / pageResizeState.imgToBrowserScale - noteHeight/ pageResizeState.imgToBrowserScale));
                        }
                    }

                } else {

                    console.log("rePositionOnBoundaryReached: mininmized " + toolState.noteList[props.pagenum][props.index].x + " ; " +  data.minimizedPos.x + " ; "  + pageResizeState.imgToBrowserScale + " ; " + data.zoomLevel + " ; " + data.noteContainerWidth + " ; " + data.noteContainerHeight)

                    if (Math.ceil(data.minimizedPos.x * pageResizeState.imgToBrowserScale * data.zoomLevel + noteMinSize * data.zoomLevel)  >= data.noteContainerWidth) {
                       // data.isPosUpdated = true;
                        updatePosX(Math.floor(data.noteContainerWidth  / data.zoomLevel / pageResizeState.imgToBrowserScale - noteMinSize / data.zoomLevel));
                        data.minimizedPos.x =  toolState.noteList[props.pagenum][props.index].x;
                    }

                    if (Math.ceil(data.minimizedPos.y * pageResizeState.imgToBrowserScale * data.zoomLevel  + noteMinSize * data.zoomLevel) >= data.noteContainerHeight) {
                       // data.isPosUpdated = true;
                        updatePosY( Math.floor(data.noteContainerHeight / data.zoomLevel / pageResizeState.imgToBrowserScale - noteMinSize / data.zoomLevel));
                        data.minimizedPos.y =  toolState.noteList[props.pagenum][props.index].y;
                    }
                }

                if (toolState.noteList[props.pagenum][props.index].title) {
                    data.title = (toolState.noteList[props.pagenum][props.index].title);
                }

                if (toolState.noteList[props.pagenum][props.index].content) {
                    data.content = (toolState.noteList[props.pagenum][props.index].content);
                }

            }


            const updateNote = ()=> {

                let meta = props.meta;

                if (data.isDragging) {
                    meta.x = toolState.noteList[props.pagenum][props.index].x;
                    meta.y = toolState.noteList[props.pagenum][props.index].y;
                    meta.minPosX = toolState.noteList[props.pagenum][props.index].x;
                    meta.minPosY = toolState.noteList[props.pagenum][props.index].y;
                }

                /*
                if (data.isMaximized) {
                    meta.minPosX = toolState.noteList[props.pagenum][props.index].x;
                    meta.minPosY = toolState.noteList[props.pagenum][props.index].y;
                }*/

                toolState.noteList[props.pagenum][props.index].title = data.title;
                toolState.noteList[props.pagenum][props.index].content = data.content;

                meta.title = data.title === undefined ? "" : data.title;
                meta.content = data.content === undefined ? "" : data.content;
                useTool().updateSingleNote(props.pagenum, meta);
            }

            /**
             * On page mode change, update the maximized state
             */
            const updateMaximizedState = ()=>{
                data.isMaximized = props.meta.isMaximized;
            }

            /**
             * Check the distance between note left edge and page image left edge
             * and the distance between note right edge and page image right edge,
             * to see if the note can fit in to the space.
             */
            const checkNoteLeftRightSpace = ()=>{
                if (noteMinSize + noteWidth * 2 > data.noteContainerWidth || noteMinSize + noteHeight * 2 > data.noteContainerHeight
                ) {
                    data.isBothLeftRightMarginNotEnough = true;
                } else {
                    data.isBothLeftRightMarginNotEnough = false;
                }

            }


            watch(
                () => data.zoomLevel,
                () => {
                    nextTick(()=> {
                        //since notes are shared on even number pages on both sides, the zoomlevel will be watched twice,
                        //avoid watching twice by setting only one side to watch:
                        if (!pageState.isRightPageAvailable && props.side === "left" ||  pageState.isRightPageAvailable ) {
                            console.log("watch data.zoomLevel @note.vue; " + props.pagenum + " ; " + data.zoomLevel + " ; " + props.side);
                            rePositionOnBoundaryReached();
                        }
                    });

                }
            )

            watch(
                () => pageState.pageMode,
                () => {
                    nextTick(()=> {
                        if (!pageState.isRightPageAvailable && props.side === "left" ||  pageState.isRightPageAvailable ) {
                            updateMaximizedState();
                        }
                    });

                }
            )

            const windowOnResized = ()=>{
                //minimize note when window is resizing, to prevent note repositioning
                data.isMaximized = false;
                //rePositionOnBoundaryReached();
            }

            const onFocusOut = (e)=>{
                console.log("on focus out!")
            }

            onMounted(()=>{
                checkNoteLeftRightSpace();
                if (deviceType() === "desktop") {
                    //rePositionOnBoundaryReached();
                    window.addEventListener("resize", windowOnResized)
                } else {
                    window.addEventListener("orientationchange", ()=>{
                        setTimeout(()=>{
                            rePositionOnBoundaryReached();
                        }, 200);
                    });
                }
            })

            return {
                i18n,
                data,
                props,
                toolState,
                refNote,
                deleteNote,
                clearActiveNote,
                getZIndex,
                onMouseDown,
                noteFieldOnMouseDown,
                updateNote,
                onFocusOut,
                setActiveNote
            }
        }
    }

</script>

<style scoped lang="scss">

    input {
        font-size:12px;
    }

    .note {
        position:absolute;
        width:$note-width;
        height:$note-height;
        background:#fff;
        border-radius:6px;
        border:$note-border-width solid $color-primary-brighter;
        box-sizing: border-box;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        user-select:none;
    }

    .minimized {
        background: url("~images/icon_notes_min.png") 0 0 no-repeat;
        background-size:26px 26px;
        width:26px !important;
        height:26px !important;
        border:none !important;
        cursor:pointer;
    }

    .minimized.disabled {
        background: url("~images/icon_notes_min_disabled.svg") 0 0 no-repeat !important;
        opacity:1;
        pointer-events:none;
    }

    .note-header {
        user-select: auto;
        background: $color-primary;
        width: 100%;
        height: $note-header-height;
        padding: 5px;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        a {
            width: 30px;
            height: 30px;
            display: flex;
            padding: 2px;
            box-sizing: border-box;

            img {
                width:100%;
            }
        }

        .title-container {
            flex: 1;
            background: #fff;
            border-radius:6px;
            display: flex;
            align-items: center;
            height:24px;
            width:100%;

            input {
                height: 0;
                width:100%;
                border-radius: 0 !important;
            }

            input.is-touch {
                height:100% !important;
                width:100%;
                border-radius:6px !important;
            }
        }
    }

    .note-content {
        width: 100%;
        height: $note-height - $note-header-height - $note-border-width * 2;
        box-sizing: border-box;
        padding: 10px;
        font-size: 14px;
        line-height:1.3em;
        border:none;
        resize:none;
        font-family:inherit;
    }

    /*
    .drag-mask {
        position:absolute;
        left:0;
        top:0;
        width:100%;
        height:100%;
        background:#fff;
        opacity:0.3;
        z-index:1;
    }*/
</style>